import classNames from 'classnames';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ColorDot, LegendContainer } from './chart-legend.styled';

type LegendItemProps = {
  label: string;
  color: string;
};

type ChartLegendProps = {
  items: LegendItemProps[];
  dotSize?: number;
  fontSize?: number;
  spaceBetween?: boolean;
  className?: string;
};

export const ChartLegend: React.FC<ChartLegendProps> = ({
  items,
  dotSize = 12,
  fontSize = 12,
  spaceBetween = false,
  className,
}) => (
  <LegendContainer className={classNames('', className, { 'space-between': spaceBetween })}>
    {items.map((item) => (
      <Stack key={item.label} direction="row" alignItems="center">
        <ColorDot color={item.color} size={dotSize} />
        <Typography sx={{ fontSize: fontSize }}>{item.label}</Typography>
      </Stack>
    ))}
  </LegendContainer>
);
